import React from "react";
import { useIntl } from "react-intl";

const About = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <h1>{formatMessage({ id: "sobre" })}</h1>

      <div className="content-box results">
        <p>{formatMessage({ id: "mensagem-sobre-1" })}</p>
        <p>{formatMessage({ id: "mensagem-sobre-2" })}</p>
      </div>
    </>
  );
};

export default About;
